export const STRATEGY_ASSISTED_TRANSFER = {
  "onSecondCallConected": function () {
    if (typeof onSecondCallConected === 'function') {
      onSecondCallConected();
    }
  },
  "onSecondCallHangUp": function (json) {
    if (typeof onSecondCallHangUp === 'function') {
      onSecondCallHangUp(json.data);
    }
  },
  "onSecondCall": function (json) {
    if (typeof onSecondCall === 'function') {
      onSecondCall(json.data);
    }
  },
  "onMainCall": function (json) {
    if (typeof onMainCall === 'function') {
      onMainCall(json.data);
    }
  },
  "onConference": function (json) {
    if (typeof onConference === 'function') {
      onConference();
    }
  },
  "onNextCall": function (json) {
    if (typeof onNextCall === 'function') {
      onNextCall(json.data);
    }
  },
}


// WEBPACK FOOTER //
// ./src/Strategies/strategyAssistedTransfer.js